import { observable, computed, action, autorun } from 'mobx';
import { AppManager } from 'core/appManager';
import { copy } from 'core/utils';

export class ConnectionAppManager extends AppManager {
  static registryName = 'ConnectionAppManager';
  disposers = [];

  @observable loadingMore = false;
  @observable batchSize;
  @observable initialBatchSize;
  @observable results = observable.map();
  @observable lastLoadedCount = 0;
  @observable startCursor = null;

  constructor(parent, initial = {}, options) {
    super(parent, initial, options);
    this.AppRef('arrayApp', this.constructor.ArrayApp);
    this.arrayApp = observable([]);
    this.disposers.push(
      autorun(
        () => {
          if (this.arrayApp.length !== 0) {
            this.lastLoadedCount = this.arrayApp.length;
          }
        },
        { name: 'lastCount' },
      ),
    );
    this.disposers.push(
      autorun(
        () => {
          const nodes = [];
          // eslint-disable-next-line
          for (const result of this.results.values()) {
            // eslint-disable-next-line
            for (const model of result.edges) {
              nodes.push(model);
            }
          }
          this.setNodes(nodes);
        },
        { name: 'ProcessConnectionResults' },
      ),
    );
  }

  @computed get totalLeft() {
    return this.totalCount - this.arrayApp.length;
  }

  @computed get loadedMore() {
    if (
      this.lastLoadedCount > this.initialBatchSize ||
      this.endCursor !== null
    ) {
      return true;
    }
    return false;
  }

  @computed get resultsArray() {
    return Array.from(this.results.values());
  }

  @computed get endCursor() {
    if (this.resultsArray.length > 0) {
      return this.resultsArray[this.resultsArray.length - 1].pageInfo.endCursor;
    }
    return null;
  }

  @computed get hasNextPage() {
    if (this.resultsArray.length > 0) {
      return this.resultsArray[this.resultsArray.length - 1].pageInfo
        .hasNextPage;
    }
    return true;
  }

  @computed get totalCount() {
    if (
      this.resultsArray.length !== 0 &&
      this.resultsArray[this.resultsArray.length - 1]
    ) {
      return this.resultsArray[this.resultsArray.length - 1].totalCount;
    }
    return 0;
  }

  @action setNodes = nodes => {
    this.arrayApp.update(nodes, true);
  };

  @computed get loading() {
    if (this.loadingMore) {
      return true;
    }
    if (this.manager) {
      return this.manager.loading;
    }
    return false;
  }

  @action moreData = (result, query) => {
    if (result !== null) {
      this.pushResult(result, query);
      this.loadingMore = false;
    }
  };

  @action Reset() {
    this.lastLoadedCount = 0;
    this.Clear();
  }

  @action Clear() {
    this.queries.clear();
    this.results.clear();
  }

  @action loadMore = options => {
    if (this.loadingMore) {
      return;
      // this.queryManager.stopQuery(qid)
    }
    this.loadingMore = true;
    // eslint-disable-next-line new-cap
    const q = new this.loadMoreQuery(this);
    q.process(this.process, this.moreData, options);
    q.query();
  };

  process = (queryResult, currResult) => {
    /* If we have a current result update it. Otherwise copy the full queryResult.
     */
    if (currResult === null && queryResult !== null) {
      currResult = copy(queryResult);
    }
    const { Model } = this.constructor.ArrayApp.ElementApp;
    if (queryResult !== null) {
      currResult.edges = queryResult.edges.map(edge => Model.Load(edge.node));
    }
    return currResult;
  };

  @action pushResult(result, query) {
    if (result !== null) {
      this.results.set(query.queryKey, result);
    }
  }

  @action pushResultIfFirst(result, query) {
    /* Either insert or update the first query */
    if (this.lastLoadedCount === 0 || this.results.get(query.queryKey)) {
      this.pushResult(result, query);
    }
  }
}
